(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ManualHelpController', ManualHelpController);

    ManualHelpController.$inject = ['$scope', '$element', '$state', '$stateParams', '$sce', '$timeout', '$window', 'ManualHelp',
        'ManualHelpContextService', 'Principal', 'AlertService'];

    function ManualHelpController($scope, $element, $state, $stateParams, $sce, $timeout, $window, ManualHelp,
        ManualHelpContextService, Principal, AlertService) {
        var vm = this;
        var markdownRootElement = null;
        var markdownClickHandler = null;
        var $body = angular.element('body');
        var wasMinifiedOnEntry = false;
        var sectionScrollRetryToken = 0;
        var sectionScrollRetryDelays = [0, 150, 400, 900, 1800];

        vm.context = ManualHelpContextService.state;
        vm.documents = [];
        vm.currentDocument = null;
        vm.documentHtml = null;
        vm.activeDocumentKey = null;
        vm.activeSectionId = null;
        vm.sectionTree = [];
        vm.canSearchAssistant = false;
        vm.canUseLlmAssistant = false;
        vm.canIndexDocuments = false;
        vm.isLoadingDocuments = false;
        vm.isLoadingDocument = false;
        vm.openDocument = openDocument;
        vm.openSection = openSection;
        vm.openSectionFromTree = openSectionFromTree;
        vm.toggleSectionNode = toggleSectionNode;
        vm.expandAllSections = expandAllSections;
        vm.collapseAllSections = collapseAllSections;
        vm.openAssistant = openAssistant;
        vm.openSearchResult = openSearchResult;
        vm.isResultForCurrentDocument = isResultForCurrentDocument;

        var sectionNodesById = {};

        activate();

        function activate() {
            // Masque le menu latéral pendant la consultation de la documentation.
            minifySidebarForDocumentation();
            registerMarkdownClickHandler();
            $scope.$on('$destroy', function() {
                sectionScrollRetryToken++;
                if (markdownRootElement && markdownClickHandler) {
                    angular.element(markdownRootElement).off('click', markdownClickHandler);
                }
                restoreSidebarState();
            });
            Principal.identity().then(function(account) {
                if (!account) {
                    return;
                }
                vm.canSearchAssistant = hasManualHelpSearchAuthority(account.authorities || []);
                vm.canUseLlmAssistant = (account.modules || []).indexOf('AI_ASSISTANT') !== -1
                    && hasAssistantAuthority(account.authorities || []);
                vm.canIndexDocuments = (account.authorities || []).indexOf('ROLE_SUPER_ADMIN') !== -1;
                ManualHelpContextService.setCapabilities(vm.canSearchAssistant, vm.canUseLlmAssistant);
            });

            loadDocuments();
        }

        function minifySidebarForDocumentation() {
            if ($body.hasClass('menu-on-top')) {
                return;
            }
            wasMinifiedOnEntry = $body.hasClass('minified');
            $body.addClass('minified');
            $body.removeClass('hidden-menu');
            angular.element('html').removeClass('hidden-menu-mobile-lock');
        }

        function restoreSidebarState() {
            if ($body.hasClass('menu-on-top') || wasMinifiedOnEntry) {
                return;
            }
            $body.removeClass('minified');
        }

        function loadDocuments() {
            vm.isLoadingDocuments = true;
            ManualHelp.query(function(result) {
                vm.documents = result || [];
                ManualHelpContextService.setDocuments(vm.documents);
                vm.isLoadingDocuments = false;

                openDocument(resolveInitialDocumentKey(), resolveInitialSectionId(), false);
            }, function() {
                vm.isLoadingDocuments = false;
                AlertService.error('Impossible de charger la liste de la documentation.');
            });
        }

        function resolveInitialDocumentKey() {
            return $stateParams.doc || ManualHelpContextService.state.activeDocumentKey || (vm.documents[0] && vm.documents[0].key);
        }

        function resolveInitialSectionId() {
            return $stateParams.section || ManualHelpContextService.state.activeSectionId || null;
        }

        function openDocument(documentKey, sectionId, clearSearchSelection) {
            if (!documentKey) {
                return;
            }
            if (clearSearchSelection !== false) {
                ManualHelpContextService.clearSearchSelection();
            }

            vm.isLoadingDocument = true;
            ManualHelp.get({key: documentKey}, function(result) {
                vm.currentDocument = result;
                vm.documentHtml = $sce.trustAsHtml((result && result.html) || '');
                vm.sectionTree = buildSectionTree((result && result.sections) || []);
                vm.activeDocumentKey = result.key;
                vm.activeSectionId = sectionId || null;
                expandSectionPath(vm.activeSectionId);
                vm.isLoadingDocument = false;

                ManualHelpContextService.setCurrentDocument(result);
                ManualHelpContextService.setActiveLocation(result.key, vm.activeSectionId);

                $state.go('manual-help', {
                    doc: result.key,
                    section: vm.activeSectionId
                }, {
                    notify: false,
                    location: 'replace'
                });

                registerMarkdownClickHandler();
                scheduleScrollToSection(vm.activeSectionId);
            }, function() {
                vm.isLoadingDocument = false;
                AlertService.error('Impossible de charger ce document.');
            });
        }

        function openSection(sectionId) {
            if (!vm.activeDocumentKey) {
                return;
            }
            vm.activeSectionId = sectionId || null;
            expandSectionPath(vm.activeSectionId);
            ManualHelpContextService.setActiveLocation(vm.activeDocumentKey, vm.activeSectionId);
            $state.go('manual-help', {
                doc: vm.activeDocumentKey,
                section: vm.activeSectionId
            }, {
                notify: false,
                location: 'replace'
            });
            scheduleScrollToSection(vm.activeSectionId);
        }

        function openSectionFromTree(sectionNode) {
            if (!sectionNode) {
                return;
            }
            if (sectionNode.children && sectionNode.children.length) {
                sectionNode.isExpanded = true;
            }
            openSection(sectionNode.id);
        }

        function toggleSectionNode(sectionNode, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            if (!sectionNode || !sectionNode.children || !sectionNode.children.length) {
                return;
            }
            sectionNode.isExpanded = !sectionNode.isExpanded;
        }

        function expandAllSections() {
            setSectionExpandedState(vm.sectionTree, true);
        }

        function collapseAllSections() {
            setSectionExpandedState(vm.sectionTree, false);
        }

        function openAssistant() {
            ManualHelpContextService.openAssistant();
        }

        function openSearchResult(result) {
            ManualHelpContextService.navigateToResult(result);
        }

        function isResultForCurrentDocument(result) {
            return !!(result && vm.activeDocumentKey && result.docKey === vm.activeDocumentKey);
        }

        function scrollToSection(sectionId) {
            var element;
            if (!sectionId) {
                $window.scrollTo(0, 0);
                return;
            }
            element = $window.document.getElementById(sectionId);
            if (element && angular.isFunction(element.scrollIntoView)) {
                element.scrollIntoView(true);
            }
        }

        function scheduleScrollToSection(sectionId) {
            var retryToken = ++sectionScrollRetryToken;
            // Retry after render because markdown content can appear and shift asynchronously.
            angular.forEach(sectionScrollRetryDelays, function(delay) {
                $timeout(function() {
                    if (retryToken !== sectionScrollRetryToken) {
                        return;
                    }
                    scrollToSection(sectionId);
                }, delay, false);
            });
        }

        function hasAssistantAuthority(authorities) {
            var index;
            for (index = 0; index < authorities.length; index++) {
                if (authorities[index] === 'ROLE_AI_ASSISTANT'
                    || authorities[index] === 'ROLE_ADMIN'
                    || authorities[index] === 'ROLE_SUPER_ADMIN') {
                    return true;
                }
            }
            return false;
        }

        function hasManualHelpSearchAuthority(authorities) {
            var index;
            for (index = 0; index < authorities.length; index++) {
                if (authorities[index] === 'ROLE_DATA_OPERATOR'
                    || authorities[index] === 'ROLE_READ_ONLY'
                    || authorities[index] === 'ROLE_AREA_MANAGEMENT'
                    || authorities[index] === 'ROLE_COLLECTOR'
                    || authorities[index] === 'ROLE_AI_ASSISTANT'
                    || authorities[index] === 'ROLE_ADMIN'
                    || authorities[index] === 'ROLE_SUPER_ADMIN') {
                    return true;
                }
            }
            return false;
        }

        function registerMarkdownClickHandler() {
            $timeout(function() {
                if (markdownRootElement && markdownClickHandler) {
                    angular.element(markdownRootElement).off('click', markdownClickHandler);
                }
                markdownRootElement = $element[0].querySelector('.manual-help-markdown');
                if (!markdownRootElement) {
                    return;
                }
                markdownClickHandler = handleMarkdownClick;
                angular.element(markdownRootElement).on('click', markdownClickHandler);
            }, 0, false);
        }

        function handleMarkdownClick(event) {
            var link = findClosestLink(event.target);
            var manualHelpTarget;
            var href;
            if (!link) {
                return;
            }
            href = link.getAttribute('href');
            if (!href) {
                return;
            }

            event.stopPropagation();
            if (href.charAt(0) === '#') {
                event.preventDefault();
                openSection(href.substring(1));
                return;
            }

            manualHelpTarget = parseManualHelpLink(href);
            if (!manualHelpTarget) {
                return;
            }

            event.preventDefault();
            if (manualHelpTarget.docKey && manualHelpTarget.docKey !== vm.activeDocumentKey) {
                openDocument(manualHelpTarget.docKey, manualHelpTarget.sectionId || null, true);
                return;
            }
            openSection(manualHelpTarget.sectionId || null);
        }

        function findClosestLink(target) {
            var current = target;
            while (current && current !== markdownRootElement) {
                if (current.tagName && current.tagName.toLowerCase() === 'a') {
                    return current;
                }
                current = current.parentNode;
            }
            return null;
        }

        function parseManualHelpLink(href) {
            var parser;
            var hashValue;
            var routeValue;
            var params;
            if (!href) {
                return null;
            }
            parser = $window.document.createElement('a');
            parser.href = href;
            if (parser.pathname && parser.pathname.indexOf('/manual-help') !== -1) {
                return {
                    docKey: readQueryParam(parser.search, 'doc'),
                    sectionId: normalizeHash(parser.hash)
                };
            }
            hashValue = parser.hash || '';
            if (hashValue.indexOf('#/manual-help') !== 0) {
                return null;
            }
            routeValue = hashValue.substring(1);
            params = routeValue.split('?')[1] || '';
            return {
                docKey: readQueryParam(params ? ('?' + params) : '', 'doc'),
                sectionId: normalizeHash(parser.hash.split('#')[2] ? ('#' + parser.hash.split('#')[2]) : '')
            };
        }

        function readQueryParam(search, key) {
            var expression = new RegExp('[?&]' + key + '=([^&#]*)');
            var match = expression.exec(search || '');
            return match && match[1] ? decodeURIComponent(match[1]) : null;
        }

        function normalizeHash(hash) {
            return hash && hash.charAt(0) === '#' ? hash.substring(1) : null;
        }

        function buildSectionTree(sections) {
            var tree = [];
            var stack = [];

            sectionNodesById = {};
            // Reconstitue l'arborescence a partir de la liste plate fournie par le backend.
            angular.forEach(sections || [], function(section) {
                var level = section && section.level ? section.level : 1;
                var sectionNode = {
                    id: section.id,
                    title: section.title,
                    level: level,
                    path: section.path,
                    children: [],
                    parentId: null,
                    isExpanded: false
                };

                while (stack.length && stack[stack.length - 1].level >= level) {
                    stack.pop();
                }

                if (stack.length) {
                    sectionNode.parentId = stack[stack.length - 1].id;
                    stack[stack.length - 1].children.push(sectionNode);
                } else {
                    tree.push(sectionNode);
                }

                sectionNodesById[sectionNode.id] = sectionNode;
                stack.push(sectionNode);
            });

            return tree;
        }

        function expandSectionPath(sectionId) {
            var sectionNode = sectionId ? sectionNodesById[sectionId] : null;
            // Garde visible la branche du chapitre actif apres navigation ou recherche.
            while (sectionNode) {
                if (sectionNode.children && sectionNode.children.length) {
                    sectionNode.isExpanded = true;
                }
                sectionNode = sectionNode.parentId ? sectionNodesById[sectionNode.parentId] : null;
            }
        }

        function setSectionExpandedState(sectionNodes, isExpanded) {
            angular.forEach(sectionNodes || [], function(sectionNode) {
                if (!sectionNode.children || !sectionNode.children.length) {
                    return;
                }
                sectionNode.isExpanded = isExpanded;
                setSectionExpandedState(sectionNode.children, isExpanded);
            });
        }
    }
})();
